import { render, staticRenderFns } from "./BcPasswordInput.vue?vue&type=template&id=1774813f"
import script from "./BcPasswordInput.vue?vue&type=script&lang=js"
export * from "./BcPasswordInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports